import { selectConfigurationState } from 'legacy/lut/features/partner360/configuration'
import { createSelector } from 'reselect'

import { getSelectedCompetitors } from 'partner360/features/competitorsSob/helpers/getSelectedCompetitors'

import { selectCompetitorsSobState } from './selectCompetitorsSobState'

export const selectSelectedCompetitors = createSelector(
  [selectCompetitorsSobState, selectConfigurationState],
  ({ data }, { programType }) => {
    const competitors = data[programType] || []
    return getSelectedCompetitors(competitors)
  }
)
